import { Reducer } from 'redux'
import { createFilter } from 'redux-persist-transform-filter'

import { UsersState, UsersActionTypes } from './types'

export const FILTER_PERSISTOR = createFilter(
  'users',
  null,
  ['list'],
  'whitelist'
)

const INITIAL_STATE: UsersState = {
  error: false,
  loading: false,
  list: []
}

const reducer: Reducer<UsersState> = (
  state = INITIAL_STATE,
  { payload, type }
) => {
  switch (type) {
    case UsersActionTypes.GET_USERS:
      return {
        ...state,
        error: false,
        loading: true
      }
    case UsersActionTypes.GET_USERS_SUCCESS:
      return {
        ...state,
        list: [...payload.list],
        loading: false
      }
    case UsersActionTypes.GET_USERS_FAILURE:
      return {
        ...state,
        list: [],
        error: true,
        loading: false
      }
    default:
      return state
  }
}

export default reducer
